export const rollerBlinds = {
  overview: {
    titles: [
      "Style and Functionality",
      "Privacy",
      "UV and Rain Protection",
      "Versatility",
    ],
    contents: [
      "Roller blinds are the perfect fusion of style and function. Framed, secure, and tidy, their aesthetic adaptability ensures that whatever your interior theme is, there is a roller blind design, pattern and material that will uplift the overall layout of your residential or commercial space.",
      "Certain materials such as block out roller blinds give you total privacy right when you need it.",
      "Roller blinds such as sunscreens protect you and your family from harmful UVA and UVB rays. Outdoors, it can effectively keep your balcony mostly dry from rains and repels insects.",
      "Roller blinds are flexible – they can cover multiple windows or individual large ones. They can be synchronised, separated or even operated in sequence. For motorised roller blinds, they can be operated by rechargeable battery or mains power. Either way, they are easy to manage.",
    ],
  },
  description: {
    titles: ["", ""],
    contents: [
      "Roller blinds have been steadily increasing in popularity in response to Newzelander’ demanding schedules. Its primary selling point is its manageability. Unlike curtains, roller blinds are easier to clean at less frequency, and it does not attract dirt like most curtain fabrics do. Unsurprisingly, it has become the more popular choice of home owners, condo dwellers, bungalows, and even commercial spaces.",
      "Although commonly used indoors, roller blinds are also used to block harsh sunlight in balcony spaces. If aesthetics is what you’re concerned about, roller blinds have a myriad of designs to fit your unique interior designs. SoHo offers roller blind colours and patterns that run the gamut of your imagination. Functionality-wise, the material options range from sunscreen for letting sunlight without the harmful UV rays in, block out for complete privacy, and even translucent fabrics to allow light into the room. SoHo also offers manual roller blind options or motorised operation using a first-grade operating system.",
    ],
  },
  summary: {
    header:
      "Simple and stylish, roller blinds are our most popular product. They’re easy to operate and maintain, and come in a number of colour ways and fabrics.",
    subItems: [
      {
        title: "BLOCKOUT ROLLER BLINDS",
        details:
          "Prevent sun light from entering any room with the specifically engineered blackout roller blinds. They’re great for optimum sleep or privacy. And parents swear by then for establishing the right sleep patterns in small children. We offer thermal blockout options to regulate heat in a room so you’re cozy in winter or cool in summer.",
      },
      {
        title: "SUNSCREEN ROLLER BLINDS",
        details:
          "Sunscreen roller blinds have a dual benefit. They cut out sunlight for glare control and provide shade to protect furnishings from harmful UV. Because they are semi-transparent you can also maintain your view while achieving privacy and light control. Available in either 3%, 5% of 10% screen, simply choose the best option for your needs.",
      },
      {
        title: "COMBINATION ROLLER BLINDS",
        details:
          "Consider combining blockout and sunscreen roller blinds on the same window to achieve the best of both worlds – complete darkness when you need it and a glare-protected view during the day.",
      },
      {
        title: "MOTORISED FOR EASE",
        details:
          "Window Answers’ roller blinds can be motorised for ease. This is a great solution if you have a large area of blinds or blinds which are difficult to access.",
      },
    ],
  },
  about: {
    header: "What we say about Roller blinds",
    col01: {
      title: "Great for…",
      items: [
        "Reducing light in bedrooms with blackout fabrics",
        "Kitchens and bathrooms with water resistant finishes",
        "Hard to reach windows or multiple blinds with motorised options",
        "Perfect Fit frames, giving a streamlined finish",
        "Skylight windows",
      ],
    },
    col02: {
      title: "Things to consider",
      items: [
        "Roller blinds are made from one piece of fabric, so they can’t be shaped around sloping or unusual windows",
        "All our Roller blinds are chain or pull-cord operated, and our advisors will fit child safety cleats as standard. Alternatively, Perfect Fit or motorised Roller blinds are cordless",
        "For a drill-free option, choose Perfect Fit blinds, which clip into your uPVC frames",
      ],
    },
  },
};
